






































import { listFactory } from '@/main/pages';
import { Partner } from '@/modules/kartoteka/partner';
import { Vozidlo } from '@/modules/kartoteka/vozidlo';
import { SubStringRezEnum } from '@/modules/ojeteVozy/constants';

import { NAME } from './constants';
import { listMutations } from './store/types';
import { store } from './store/list';

export default listFactory(NAME, store).extend({
	components: {
		ZakaznikSelect: Partner.components.Select,
		VozidloSelect: Vozidlo.components.Select,
	},
	data() {
		return {
			mutationsMappers: {
				vozidlo: `${this.storeUri}/${listMutations.VOZIDLO_SELECT_MAPPER}`,
				zakaznik: `${this.storeUri}/${listMutations.ZAKAZNIK_SELECT_MAPPER}`,
			},
		};
	},
	computed: {
		vozidloFilter() {
			return {
				VyrobekvozOzn: this.VyrobekvozOzn,
				Spz: this.Spz,
			};
		},
		spzSubstrOptions() {
			const enumMembers = Object.keys(SubStringRezEnum).map((key: any) => SubStringRezEnum[key]);
			const enumKeys = enumMembers.filter((v) => typeof v !== 'number');
			return enumKeys.map((key: any) => {
				const Value = SubStringRezEnum[key];
				return {
					Disabled: false,
					Text: this.LocalizePopisostatni(`Vinsubstr_rez${Value}`),
					Value,
					Label: undefined,
				};
			});
		},
	},
	methods: {
		updateEetPrp(eetPrp: boolean | null) {
			this.EetCommunicStatusPznList = eetPrp ? this.dropdownList.EetCommunicStatusPznList.map((ddValue: any) => ddValue.Value) : [];
		},
	},
});
